import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContainerApps } from '../../store/slices/monitoringSlice';
import { RootState, AppDispatch } from '../../store';
import ContainerAppsList from '../../components/monitoring/ContainerAppsList';
import AlertsPanel from '../../components/monitoring/AlertsPanel';
import StatusSummary from '../../components/monitoring/StatusSummary';
import MonitoringFilters from '../../components/monitoring/MonitoringFilters';

const MonitoringPage: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { containerapps, loading, error, alerts } = useSelector((state: RootState) => state.monitoring);
    const [selectedStatus, setSelectedStatus] = useState<string>('all');
    useEffect(() => {
        dispatch(fetchContainerApps());
        // Set up polling interval to refresh data every minute
        const interval = setInterval(() => {
            dispatch(fetchContainerApps());
        }, 60000);

        return () => clearInterval(interval);
    }, [dispatch]);

    const filteredApps = selectedStatus === 'all'
        ? containerapps
        : containerapps.filter(app => app.status === selectedStatus);

    const handleStatusChange = (status: string) => {
        setSelectedStatus(status);
    };

    if (loading && containerapps.length === 0) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary-500"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                <p>Error: {error}</p>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-800 dark:text-white">Monitoring Dashboard</h1>
                <MonitoringFilters selectedStatus={selectedStatus} onStatusChange={handleStatusChange} />
            </div>

            <StatusSummary containerApps={containerapps} />

            {alerts.length > 0 && (
                <div className="mb-6">
                    <h2 className="text-xl font-semibold mb-3 text-gray-800 dark:text-white">Active Alerts</h2>
                    <AlertsPanel alerts={alerts} />
                </div>
            )}

            <div className="mt-6">
                <h2 className="text-xl font-semibold mb-3 text-gray-800 dark:text-white">Container Applications</h2>
                <ContainerAppsList containerApps={filteredApps} />
            </div>
        </div>
    );
};

export default MonitoringPage;